import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import { CandidatesContext } from '../../../../context/CandidatesContext';
import classes from './styles.module.scss';

export default function InviteCandidateButton({ candidateId }) {
  const { showInviteToJobModal } = useContext(CandidatesContext);

  const { t } = useTranslation();

  return (
    <button
      className={classes.InviteCandidateButton}
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        showInviteToJobModal(candidateId);
      }}
    >
      <span>{t('common.invite')}</span>
    </button>
  );
}
